"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Span = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > * {\n    display: block;\n  }\n"], ["\n  & > * {\n    display: block;\n  }\n"])));
var CaretDown = function (_a) {
    var color = _a.color;
    return (react_1.default.createElement(Span, null,
        react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M16.3846 8L18 9.60269L12 15.5556L6 9.60269L7.61538 8L12 12.3502L16.3846 8Z", fill: color || '#2362A2' }))));
};
CaretDown.defaultProps = {
    color: undefined,
};
exports.default = CaretDown;
var templateObject_1;
